import { z } from 'zod';

export const DisplayVariant = z.enum(['grid', 'social']);

export type DisplayVariant = z.infer<typeof DisplayVariant>;
